import { render } from "./AddSubRoute.vue?vue&type=template&id=17aa491b"
import script from "./AddSubRoute.vue?vue&type=script&lang=js"
export * from "./AddSubRoute.vue?vue&type=script&lang=js"
script.render = render

export default script